export const FRONT_TEXT_CENTER_TASK_REQUEST_TENANT_CONFIRMATION_FOR_TOUR_DATE =
  'requestTenantConfirmationForTourDate'; // eslint-disable-line max-len
export const FRONT_TEXT_CENTER_TASK_REQUEST_RENTER_TOURING_CONFIRMATION =
  'requestRenterTouringConfirmation'; // eslint-disable-line max-len
export const FRONT_TEXT_CENTER_TASK_APARTMENT_LOCATOR_INTRO_TEXT = 'apartmentLocatorIntroText'; // eslint-disable-line max-len
export const FRONT_TEXT_CENTER_TASK_NEEDS_RESCHEDULING_TOUR_FOLLOWUP =
  'needsReschedulingTourFollowup'; // eslint-disable-line max-len
export const FRONT_TEXT_CENTER_TASK_HOUSHOLD_APPLICATION_WTA_FOLLOW_UP =
  'householdApplicationWTAFollowUp';
export const FRONT_TEXT_CENTER_TASK_PREQUALIFICATION_FOLLOW_UP = 'prequalificationFollowUp';
export const FRONT_TEXT_CENTER_TASK_RENTLINX_LEAD_REQUEST_TOUR = 'rentlinxLeadRequestTour';
export const FRONT_TEXT_CENTER_TASK_INCOME_VERIFICATION = 'incomeVerificationReminder';
export const FRONT_TEXT_CENTER_TASK_RENTLINX_LEAD_REQUEST_TOUR_FOLLOW_UP =
  'rentlinxLeadRequestTourFollowUp';
export const FRONT_TEXT_CENTER_TASK_RENTLINX_LEAD_REQUEST_TOUR_EMAIL =
  'rentlinxLeadRequestTourEmail';
export const FRONT_TEXT_CENTER_TASK_HOUSEHOLD_APPLICATION_PAY_DEPOSIT =
  'householdApplicationPayDeposit';
export const FRONT_TEXT_CENTER_TASK_INVITE_RENTER_AGENT_TO_APP_TRACKER =
  'inviteRenterAgentToAppTracker';
export const FRONT_TEXT_CENTER_TASK_SEND_MOBILE_APP_DOWNLOAD_LINK = 'sendMobileAppDownloadLink';
export const FRONT_TEXT_CENTER_TASK_VERIFICATION_OF_EMPLOYMENT = 'verificationOfEmployment';
export const FRONT_TEXT_CENTER_TASK_VERIFICATION_OF_RENTAL = 'verificationOfRental';
export const FRONT_TEXT_CENTER_TASK_SUPRA_SHOWING_FEEDBACK = 'supraShowingFeedback';
export const FRONT_TEXT_CENTER_TASK_OWNER_INVITE_REMINDER = 'ownerInviteReminder';
export const FRONT_TEXT_CENTER_TASK_BACKUP_HOUSEHOLD_APPLICATION = 'backupHouseholdApplication';
export const FRONT_TEXT_CENTER_TASK_PROCESSING_HOUSEHOLD_APPLICATION =
  'processingHouseholdApplication';
export const FRONT_TEXT_CENTER_TASK_SUNSCREEN_APPLICATION_STARTED = 'sunScreenApplicationStarted';
export const FRONT_TEXT_CENTER_TASK_SUNSCREEN_APPLICATION_SUBMITTED =
  'sunScreenApplicationSubmitted';
export const FRONT_TEXT_CENTER_TASK_PROCESSING_SUNSCREEN_APPLICATION =
  'processingSunScreenApplication';
export const FRONT_TEXT_CENTER_TASK_HOUSEHOLD_APPLICATION_COMPLETE_PET_SCREENING =
  'householdApplicationCompletePetScreening'; // eslint-disable-line max-len
export const FRONT_TEXT_CENTER_TASK_PRE_LEASE_LISTING_ENDING_SOON = 'preLeaseEndingSoon';
export const FRONT_TEXT_CENTER_TASK_PRE_LEASE_LISTING_ENDED = 'preLeaseEnded';
export const FRONT_TEXT_CENTER_TASK_JOB_ON_OCCUPIED_HOME = 'jobOnOccupiedHome';

export const FRONT_TEXT_CENTER_STATUS_CREATED = 'Created';
export const FRONT_TEXT_CENTER_STATUS_SCHEDULED = 'Scheduled';
export const FRONT_TEXT_CENTER_STATUS_ACTIVE = 'Active';
export const FRONT_TEXT_CENTER_STATUS_COMPLETED = 'Completed';
export const FRONT_TEXT_CENTER_STATUS_NO_RESPONSE = 'NoResponse';
export const FRONT_TEXT_CENTER_STATUS_CANCELLED = 'Cancelled';
